module.exports = __webpack_public_path__ + "static/img/peeling_skin-01.d3f3f81.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/peeling_skin-01.jpg
// module id = 283
// module chunks = 1